import { useContext, useEffect, useState } from "react";
import { StandardComp } from "../atoms/standardComp";
import { CourseTableComp, SuggestCourseTableComp } from "../components/courseTableComp";
import { GraphComp } from "../components/graphComp";
import { KpiComp } from "../components/kpiComp";
import { HorizontalLayout, VerticalLayout, VerticalPageLayout } from "../components/layout";
import { RecentActivities } from "../components/recentActivities";
import { TopBar } from "../components/topbar";
import { ReportsOverview } from "../molecule/reportsOverview";
import { getAPI, postAPI, updateAPI } from "../api/api";
import { SuggestedCourseGrid } from "../components/suggestCourse";
import { Alert } from "../components/alert";
import { SuggestionModal } from "../components/customModals";
import { StandardButton } from "../atoms/buttons";
import { HeaderTitle } from "../molecule/headerTitle";
import { ShowLayoutError } from "../molecule/ShowErrorLayout";
import { Toast } from "../atoms/toast";
import { vi } from "date-fns/locale";
import { PageContext, UserContext } from "../App";


export function Reports({ pageSwap, props }) {
    const [suggestionVisible, setSuggestionVisible] = useState(false);
    const openSuggestionModal = () => setSuggestionVisible(true);
    const closeSuggestionModal = () => setSuggestionVisible(false);
    const [kpiContents, setKpiContents] = useState({})
    const [showMore, setShowMore] = useState(false);
    const [allCourses, setAllCourses] = useState([]);
    const [selectedCourseIds, setSelectedCourseIds] = useState([]);
    const [visibleKpiKeys, setVisibleKpiKeys] = useState([]);
    const [period, setPeriod] = useState(12);
    const [allReports, setAllReports] = useState([]);
    const [graphDataset, setGraphDataset] = useState([]);
    const [activeGraphId, setActiveGraphId] = useState("1");
    const [errorMessage, setErrorMessage] = useState("");
    const [userCourseStats, setUserCourseStats] = useState([]);
    const navigationContext = useContext(PageContext);
    const userContext = useContext(UserContext)
    const isPublic  = userContext.account_type === 1
    useEffect(() => {
        
        loadCourses();
    }, []);


    
    const loadCourses = async () => {
        const query = `api/courses/filter?filter=creation_date&order=DESC&published_filters=active_lessons`;
        const response = await getAPI(query);
        const courses = response.data;
        setAllCourses(courses);
    };
    
        

        useEffect(() => {
        if (navigationContext.sidebar?.courseID && allCourses.length > 0) {
            const id = navigationContext.sidebar.courseID;
            handleCourseToggle(id, true);
        }
    }, [allCourses, navigationContext.sidebar?.courseID]);
    
      
      const handleCourseToggle = (id, override = false) => {
        setErrorMessage("");
        if (override) {
            setSelectedCourseIds([id]);
            return;
        }


        setSelectedCourseIds((prev) => {
            if (prev.includes(id)) {
                const newSelected = prev.filter((cid) => cid !== id);
                setUserCourseStats(allCourses.filter(course => newSelected.includes(course.id_course)));
                return newSelected
            } else {
                if (prev.length >= 5) {
                    setErrorMessage("Je kunt maximaal 5 cursussen selecteren.");
                    setTimeout(() => {
                        setErrorMessage("");
                    }, 3500);
                    return prev;
                }

                const newSelected = [...prev, id];
                setUserCourseStats(allCourses.filter(course => newSelected.includes(course.id_course)));
            
                return newSelected;
            }
        });
        
    };

    const [isMobile, setIsMobile] = useState(false);

    useEffect(() => {
        const checkMobile = () => {
            setIsMobile(window.innerWidth < 768); 
        };
        checkMobile();

        window.addEventListener("resize", checkMobile);
        return () => window.removeEventListener("resize", checkMobile);
    }, []);
    const displayedCourses = showMore ? allCourses : (isMobile ? allCourses.slice(0, 2) : allCourses.slice(0, 4));

    const handleActiveGraph = (id) => {
        setActiveGraphId((prev) => (prev === id ? id : id));
         setGraphDataset(kpiContents[id].graph_array.map((item) => (parseInt(item.row_value))));
    };

    if (allCourses.length === 0 && kpiContents.length === 0) {
        return (
            <ShowLayoutError
                iconType="no-reports"
                errorTitle="Geen suggesties beschikbaar"
                message="Er zijn momenteel geen rapportages of aanbevelingen om weer te geven."
            />
        );
    }

    return (
        <>
            {errorMessage && (
                <Toast
                    className={"max-course-alert"}
                    message={errorMessage}
                    type="error"
                    duration={3500}
                />
            )}
            {suggestionVisible && (
                <SuggestionModal
                    ref={null}
                    visible={suggestionVisible}
                    dismiss={closeSuggestionModal}
                    position={"center"}
                />
            )}


            <VerticalPageLayout className={`page-in-animation ${pageSwap && "page-out-animation"}`}>
                <HorizontalLayout style={{ width: "auto" }} className={"standard-padding"}>
                    <HeaderTitle title={"Rapporten"} />
                    <StandardButton className={"show-button"} size="medium" title={showMore ? "Toon minder" : "Toon meer"} onClick={() => setShowMore(!showMore)} />
                </HorizontalLayout>
                {allCourses.length > 0 && <SuggestedCourseGrid showMore={showMore}  selectedCourseIds={selectedCourseIds} selectCourse={handleCourseToggle} coursesToDisplay={displayedCourses} />}
                <Alert onClick={openSuggestionModal} className={"suggest-alert"} type="suggestion" buttonText={"Leer meer"} title={"Suggesties"} message={"Leer hoe je het maximale uit je e-learning kan halen met onze op maat gemaakte suggesties."} />
  
                        <VerticalLayout className="phone-raports-container">
                            <ReportsOverview handleActiveGraph={handleActiveGraph} activeGraphId={activeGraphId} selectedCourses={selectedCourseIds}  graphDataset={graphDataset} courses={allCourses} setPeriod={setPeriod} period={period} keys={visibleKpiKeys} kpiContent={kpiContents} allReports={allReports} />
                        </VerticalLayout>
                        <VerticalLayout className="phone-raports">
                            <SuggestCourseTableComp margin={"0.8rem"} title={isPublic ? "Leads":"Cursiststatistieken"} courses={userCourseStats} />
                        </VerticalLayout>
          
           
            </VerticalPageLayout>
        </>

    );
}
